import { HoopsApi, useAPIQueryAndQueryKey } from "melco-shared-logic";
import { PublishState } from "../../helper/publishedState";

export const useManageHoopsGetDef = (
  hoopId: string,
  publishState: PublishState
) => {
  let res = useAPIQueryAndQueryKey(
    HoopsApi,
    ["useManageHoopsGetDef", hoopId, publishState],
    async (api) => {
      let response = await api.hoopsGetDef({
        id: hoopId,
        publishState: publishState,
      });




      return response;
    }
  );

  console.log(res);
  return res;
};
